import { __rest, __assign } from 'tslib';
import React, { useContext, useCallback, useEffect } from 'react';
import cn from 'classnames';
import { NavigationBarPrivate } from '@alfalab/core-components-navigation-bar-private/esm';
import { getDataTestId } from '@alfalab/core-components-shared/esm';
import { SIZE_TO_CLASSNAME_MAP } from '../../consts.js';
import { ModalContext } from '../../Context.js';
import { ResponsiveContext } from '../../ResponsiveContext.js';

var desktopStyles = {"header":"modal__header_1dsqa","content":"modal__content_1dsqa","size-500":"modal__size-500_1dsqa","size-600":"modal__size-600_1dsqa","size-800":"modal__size-800_1dsqa","size-1140":"modal__size-1140_1dsqa","fullscreen":"modal__fullscreen_1dsqa","sticky":"modal__sticky_1dsqa"};
require('./desktop.css')

var styles = {"highlighted":"modal__highlighted_f04ks","sticky":"modal__sticky_f04ks","hasContent":"modal__hasContent_f04ks"};
require('./index.css')

var mobileStyles = {"header":"modal__header_nwnim","sticky":"modal__sticky_nwnim","content":"modal__content_nwnim"};
require('./mobile.css')

var Header = function (_a) {
    var _b, _c;
    var className = _a.className, sticky = _a.sticky, title = _a.title, children = _a.children, contentClassName = _a.contentClassName, _d = _a.hasCloser, hasCloser = _d === void 0 ? true : _d, onHeaderClose = _a.onClose, restProps = __rest(_a, ["className", "sticky", "title", "children", "contentClassName", "hasCloser", "onClose"]);
    var _e = useContext(ModalContext), setHasHeader = _e.setHasHeader, headerHighlighted = _e.headerHighlighted, parentRef = _e.parentRef, onClose = _e.onClose;
    var _f = useContext(ResponsiveContext), view = _f.view, size = _f.size, dataTestId = _f.dataTestId;
    var handleClose = useCallback(function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        if (onHeaderClose) {
            onHeaderClose.apply(void 0, params);
        }
        if (onClose) {
            onClose.apply(void 0, params);
        }
    }, [onHeaderClose, onClose]);
    useEffect(function () {
        setHasHeader(true);
    }, [setHasHeader]);
    var hasContent = Boolean(title || children);
    return (React.createElement(NavigationBarPrivate, __assign({ dataTestId: getDataTestId(dataTestId, 'header') }, restProps, { scrollableParentRef: parentRef, hasCloser: hasCloser, sticky: sticky, view: view, title: title, onClose: handleClose, className: cn(className, (_b = {},
            _b[styles.highlighted] = hasContent && sticky && headerHighlighted,
            _b[styles.sticky] = sticky,
            _b[styles.hasContent] = hasContent,
            _b[desktopStyles.header] = view === 'desktop',
            _b[desktopStyles.sticky] = view === 'desktop' && sticky,
            _b[desktopStyles[SIZE_TO_CLASSNAME_MAP[size]]] = view === 'desktop',
            _b[mobileStyles.header] = view === 'mobile',
            _b[mobileStyles.sticky] = view === 'mobile' && sticky,
            _b)), contentClassName: cn(contentClassName, (_c = {},
            _c[desktopStyles.content] = view === 'desktop',
            _c[mobileStyles.content] = view === 'mobile',
            _c)) }), children));
};

export { Header };
